import React from "react";
import Select from "react-select";

const SelectComponentMulti = (props) => {

    //let values = [{ value: 2, label: "rojo" },{ value: 3, label: "verde" }];
    return (
        <div>
            <label className="block font-medium">{props.label}</label>
            <Select closeMenuOnSelect={false} isMulti options={props.options ?? []} {...props} defaultValue={props.defaultValue} isClearable={true} isDisabled={props.isDisabled ?? false} />
        </div>
    )
}

export default SelectComponentMulti;